<template>
  <div v-if="currentPost" class="sidenav-announcement-stack" :style="stackWrapStyle">
    <div
      v-for="n in peekCount"
      :key="'peek-' + n"
      class="sidenav-announcement-peek"
      :style="peekStyle(n)"
    ></div>
    <a
      class="sidenav-announcement"
      :href="channelLink"
      target="_blank"
      rel="noopener"
    >
      <div class="sidenav-announcement__header">
        <span class="sidenav-announcement__title">{{ $t('Announcement.Title') }}</span>
        <button
          class="sidenav-announcement__close"
          :title="$t('General.Close')"
          :aria-label="$t('General.Close')"
          @click.prevent.stop="dismiss(currentPost)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <img v-if="imageUrl" :src="imageUrl" class="sidenav-announcement__img" alt="" />
      <p v-if="description" class="sidenav-announcement__desc">{{ description }}</p>
    </a>
  </div>
</template>

<script>
import StrapiService from "@/helpers/api/strapi.service";

const CATEGORY_SLUG = 'updates-mng';
const CHANNEL_LINKS = {
  ru: 'https://t.me/+MgHFkkaapGowNmMy',
  en: 'https://t.me/+BBNcRlwQwmA1OTky',
};
const MAX_VISIBLE_PEEKS = 2;

export default {
  name: "sidenav-announcement",
  data() {
    return {
      posts: [],
    };
  },
  computed: {
    currentPost() {
      return this.posts[0] || null;
    },
    peekCount() {
      return Math.min(this.posts.length - 1, MAX_VISIBLE_PEEKS);
    },
    stackWrapStyle() {
      return { paddingBottom: `${this.peekCount * 6}px` };
    },
    imageUrl() {
      return StrapiService.getImageUrl(this.currentPost?.Image);
    },
    description() {
      return this.currentPost?.Description || '';
    },
    channelLink() {
      const locale = this.$i18n?.locale;
      return CHANNEL_LINKS[locale] || CHANNEL_LINKS.en;
    },
  },
  watch: {
    '$i18n.locale': 'fetchPosts',
  },
  mounted() {
    this.fetchPosts();
  },
  methods: {
    dismissedKey(post) {
      return post ? `sidenav_announcement_dismissed_${post.id}` : null;
    },
    peekStyle(n) {
      return {
        bottom: `${-6 * n}px`,
        left: `${6 * n}px`,
        right: `${6 * n}px`,
        zIndex: MAX_VISIBLE_PEEKS - n,
        opacity: 1 - n * 0.25,
      };
    },
    async fetchPosts() {
      let posts = [];
      try {
        posts = await StrapiService.getLatestPostsByCategory(CATEGORY_SLUG, this.$i18n?.locale || 'en');
      } catch (_) {
        posts = [];
      }
      this.posts = posts.filter((post) => localStorage.getItem(this.dismissedKey(post)) !== '1');
      this.$nextTick(() => this.$emit('loaded'));
    },
    dismiss(post) {
      const key = this.dismissedKey(post);
      if (key) {
        localStorage.setItem(key, '1');
      }
      this.posts = this.posts.filter((p) => p.id !== post.id);
      this.$nextTick(() => this.$emit('loaded'));
    },
  },
};
</script>

<style scoped>
.sidenav-announcement-stack {
  position: relative;
  margin: 0 12px 10px;
}

.sidenav-announcement-peek {
  position: absolute;
  height: 16px;
  border-radius: 0 0 10px 10px;
  border: 1px solid var(--ui-border);
  border-top: none;
  background: var(--ui-bg-card);
  transition: all 0.2s ease;
}

.sidenav-announcement {
  position: relative;
  z-index: 3;
  display: block;
  border-radius: 12px;
  border: 1px solid var(--c-primary-bd);
  background: var(--c-primary-bg);
  overflow: hidden;
  text-decoration: none !important;
  transition: box-shadow 0.15s ease;
}
.sidenav-announcement:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.sidenav-announcement__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px 8px;
}

.sidenav-announcement__title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--c-primary-fg);
}

.sidenav-announcement__img {
  display: block;
  width: 100%;
  height: 90px;
  object-fit: cover;
}

.sidenav-announcement__desc {
  margin: 0;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ui-text-2);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sidenav-announcement__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--ui-text-3);
  font-size: 11px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.sidenav-announcement:hover .sidenav-announcement__close {
  opacity: 1;
}
.sidenav-announcement__close:hover {
  background: var(--ui-border);
  color: var(--ui-text-1);
}
</style>
